import React, { useEffect } from "react";
import useState from 'react-usestateref';
import { Typography, Button, Box, Divider, TextField, Paper,Alert,Table,TableHead,TableCell,Chip,TableRow,TableBody } from "@mui/material";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { getAuthHeader } from "../authorization/FetchToken";
import { useAuth } from "./AuthContext";
import Snackbar from '@mui/material/Snackbar';
import Spinner from '../Spinner';



const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

/* ---------------- CARD UPDATE FORM ---------------- */

function UpdateCard({ customerId, callApi, onUpdated,setCard,setSuccess,setError,org,user }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false)

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const cardElement = elements.getElement(CardElement);
      const card = elements.getElement(CardElement);

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card,
      });

      if (error) {
        setError(error.message);
        setLoading(false);
        return;
      }

      await callApi("/attachPayment", {
        customerId,
        paymentMethodId: paymentMethod.id,
      });

      setSuccess("Card updated successfully");
      onUpdated();

    const updateCard = await callGetApi("/getPaymentMethod", {
      customerId: customerId,
    });
    console.log("CARD:", updateCard);

    setCard(updateCard);
    cardElement.clear();
    setLoading(false);
    await callApi("/sendEmailLink", {
      email:org + "`" + user,
      emailType:"update_card",
      creatorEmail: "",
      orgName:org
  });

  } catch (err) {
    setError(err.message);
  }
};

  return (
    <form onSubmit={handleUpdate}>
      <Box sx={{ border: "1px solid #ddd", p: 2, borderRadius: 2 }}>
        <CardElement />
      </Box>

      <Button
        type="submit"
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        disabled={!stripe || loading}
      >
        {loading ? "Updating..." : "Update Card"}
      </Button>
    </form>
  );
}

const callGetApi = async (endpoint, params = {}) => {
  const queryString = new URLSearchParams(params).toString();

  const url = queryString
    ? `${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}${endpoint}?${queryString}`
    : `${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}${endpoint}`;

  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(await getAuthHeader()),
    },
  });

  if (!resp.ok) {
    throw new Error(await resp.text());
  }

  return resp.json();
};

const callApi = async (endpoint, body) => {
  const resp = await fetch(
    `${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}${endpoint}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(await getAuthHeader()),
      },
      body: JSON.stringify(body),
    }
  );

  if (!resp.ok) {
    throw new Error(await resp.text());
  }

  return resp.json();
};

/* ---------------- MAIN PAGE ---------------- */

export default function BillingPage() {
  const [card, setCard] = useState(null);
  const [customerId, setCustomerId, customerIdRef] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [selectedTab, setSelectedTab] = useState("payment");
  const [invoicesLoaded, setInvoicesLoaded] = useState(false);
  const [searchDate, setSearchDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
    const [billingDetails, setBillingDetails] = useState({
    billingContact: card?.Metadata?.billing_contact || "",
    line1: card?.BillingDetails?.address?.line1 || "",
    line2: card?.BillingDetails?.address?.line2 || "",
    city: card?.BillingDetails?.address?.city || "",
    state: card?.BillingDetails?.address?.state || "",
    postalCode: card?.BillingDetails?.address?.postal_code || "",
    country: card?.BillingDetails?.address?.country || "",
  });
  const [loading, setLoading] = useState(false)

   const [paymentMethod, setPaymentMethod] = useState(false)

  const { userSessionRef } = useAuth();
  const elements = useElements();
  const stripe = useStripe();

  console.log("userSessionRef.current::1", userSessionRef.current["orgName"]);
  // adjust based on how you store Stripe customerId
  const org = userSessionRef.current["orgName"];
  const role = userSessionRef.current["role"];
  const user = userSessionRef.current["userName"];
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [cancelSuccess, setCancelSuccess] = useState(false);
  /* Load data */

  useEffect(() => {
    loadData();
  }, [userSessionRef.current]);

  useEffect(() => {
    loadInvoices();
  }, [userSessionRef.current]);


  if (!userSessionRef.current) {
    return <div>Loading session...</div>;
  }

  const loadData = async () => {
    try {
      setLoading(true)
      // adjust based on how you store Stripe customerId
      const result = await callApi("/getCustomerWithOrgName", {
        OrgName: org,
      });

      const cust = result.customers[0];
      console.log("CUSTOMER:", cust?.address?.state);
      setCustomerId(cust.id);

      const card = await callGetApi("/getPaymentMethod", {
        customerId: cust.id,
      });
      console.log("CARD:", card);

      setCard(card);
    
    setBillingDetails({
      billingContact: card?.Metadata?.billing_contact || "",
      line1: cust?.address?.line1 || "",
      line2: cust?.address?.line2 || "",
      city: cust?.address?.city || "",
      state: cust?.address?.state || "",
      postalCode: cust?.address?.postal_code || "",
      country: cust?.address?.country || "",
    });

      const data = await callApi("/getInvoices", {
        customerId: cust.id,
      });
  
      setInvoices(data || []);
      setLoading(false)
    } catch (err) {
      console.error(err);
      setLoading(false)
    }
  };

const updateBillingAddress = async (e) => {
      e.preventDefault();
      setLoading(true);
  
      try {
        const { updateBillingAddress, billingError } = await callApi("/updateBillingDetails", {
          customerId: customerId,
          billing_contact_name: billingDetails.billingContact,
          line1: billingDetails.line1,
          line2: billingDetails.line2,
          city: billingDetails.city,
          state: billingDetails.state,
          postal_code: billingDetails.postalCode,
          country: billingDetails.country,
      });
      if (billingError) {
        setError(error.message);
        setLoading(false);
        return;
      }
        
      setSuccess("Biiling Details updated successfully");
      //onUpdated();
  
      //setBillingDetails(updateCard);
      setLoading(false);
      await callApi("/sendEmailLink", {
        email:org + "`" + user,
        emailType:"update_card",
        creatorEmail: "",
        orgName:org
    });
  
    } catch (err) {
      setError(err.message);
    }
  }

  const loadInvoices = async () => {
    const data = await callApi("/getInvoices", {
      customerId: customerIdRef.current,
    });
    console.log("invoices::1",data)
    setInvoices(data || []);
  };
  

  const filteredInvoices = invoices.filter((inv) => {
    const d = new Date(inv.created * 1000);
  
    const monthMatch = selectedMonth
      ? d.getMonth() + 1 === Number(selectedMonth)
      : true;
  
    const yearMatch = selectedYear
      ? d.getFullYear() === Number(selectedYear)
      : true;
  
    return monthMatch && yearMatch;
  });

  const handleBillingChange = (field, value) => {
    setBillingDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  
  const canelAccount = async () => {
    try {
      setLoading(true);
  
      await callApi("/cancelAccount", {
        email: user,
        emailType: "cancel_email",
        orgName: org,
      });
  
      setCancelSuccess(true);
      setDeleteConfirmation("");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    role === "ROOT" || role === "INDIVIDUAL_USER" ?  (
  <div style={{ display: "flex", padding: 72, maxWidth: 1600, margin: "0 auto", gap: 32 }}>
        {loading && (
      <div className="overlay">
        <div className="loading-container">
          <Spinner />
          <p className="please-wait">Please wait...</p>
        </div>
      </div>
    )}
  {/* ---------------- SIDEBAR ---------------- */}
  <div
    style={{
      width: 220,
      borderRight: "1px solid #eee",
      paddingRight: 16,
    }}
  >
    <Typography variant="h5">Billing</Typography>
    <Divider sx={{ my: 2 }} />

    <div
      onClick={() => setSelectedTab("payment")}
      style={{
        padding: 12,
        cursor: "pointer",
        background: selectedTab === "payment" ? "#f3f4f6" : "transparent",
        borderRadius: 8,
        marginBottom: 8,
        fontWeight: 500,
      }}
    >
      Payment Method
    </div>

    <div
      onClick={async () => {
        setSelectedTab("invoices");

        if (!invoicesLoaded) {
          await loadInvoices();
          setInvoicesLoaded(true);
        }
      }}
      style={{
        padding: 12,
        cursor: "pointer",
        background: selectedTab === "invoices" ? "#f3f4f6" : "transparent",
        borderRadius: 8,
        fontWeight: 500,
      }}
    >
      Invoices
    </div>

    <div
      onClick={async () => {
        setSelectedTab("cancel_account");
      }}
      style={{
        padding: 12,
        cursor: "pointer",
        background: selectedTab === "cancel_account" ? "#f3f4f6" : "transparent",
        borderRadius: 8,
        fontWeight: 500,
      }}
    >
      Cancel Account
    </div>

  </div>

  {/* ---------------- MAIN CONTENT ---------------- */}
  <div style={{ flex: 1 }}>

    <Snackbar
      open={!!success}
      autoHideDuration={30000}
      onClose={() => setSuccess("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="success" onClose={() => setSuccess("")}>
        {success}
      </Alert>
    </Snackbar>

    <Snackbar
      open={!!error}
      autoHideDuration={30000}
      onClose={() => setError("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="error" onClose={() => setError("")}>
        {error}
      </Alert>
    </Snackbar>

    {/* ---------------- PAYMENT TAB ---------------- */}
    {selectedTab === "payment" && (
      <>
        <Typography variant="h6">Current Payment Method</Typography>
        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            p: 3,
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            mb: 3,
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          {card?.hasCard ? (
            <>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "text.secondary",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  mb: 2,
                }}
              >
                Default Payment Method
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {card.brand?.toUpperCase()} •••• {card.last4}
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    Expires {card.expMonth}/{card.expYear}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 10,
                    backgroundColor: "#ecfdf5",
                    color: "#065f46",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                  }}
                >
                  Active
                </Box>
              </Box>
            </>
          ) : (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography>No payment method on file</Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            p: 3,
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            mb: 3,
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          {card?.hasCard ? (
            <>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "text.secondary",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  mb: 2,
                }}
              >
                Billing Details
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <TextField
        label="Billing Contact"
        value={billingDetails.billingContact}
        onChange={(e) =>
          handleBillingChange("billingContact", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="Address Line 1"
        value={billingDetails.line1}
        onChange={(e) =>
          handleBillingChange("line1", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="Address Line 2"
        value={billingDetails.line2}
        onChange={(e) =>
          handleBillingChange("line2", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="City"
        value={billingDetails.city}
        onChange={(e) =>
          handleBillingChange("city", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="State / Province"
        value={billingDetails.state}
        onChange={(e) =>
          handleBillingChange("state", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="Postal Code"
        value={billingDetails.postalCode}
        onChange={(e) =>
          handleBillingChange("postalCode", e.target.value)
        }
        fullWidth
      />

      <TextField
        label="Country"
        value={billingDetails.country}
        onChange={(e) =>
          handleBillingChange("country", e.target.value)
        }
        fullWidth
      />

      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={updateBillingAddress}
        >
          Update Billing Address
        </Button>
      </Box>
    </Box>

                <Box
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 10,
                    backgroundColor: "#ecfdf5",
                    color: "#065f46",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                  }}
                >
                  Active
                </Box>
              </Box>
            </>
          ) : (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography>No payment method on file</Typography>
            </Box>
          )}
        </Box>


        <Typography variant="h6">Update Card</Typography>
        <Elements stripe={stripePromise}>
          <UpdateCard
            customerId={customerId}
            callApi={callApi}
            onUpdated={loadData}
            setCard={setCard}
            setSuccess={setSuccess}
            setError={setError}
            org={org}
            user={user}
          />
        </Elements>
      </>
    )}

    {/* ---------------- INVOICES TAB ---------------- */}
    {selectedTab === "invoices" && (
      <>
        <Typography variant="h6">Invoices</Typography>
        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>

<Typography variant="body2" sx={{ fontWeight: 500 }}>
  Filter:
</Typography>

{/* Month */}
<select
  value={selectedMonth}
  onChange={(e) => setSelectedMonth(e.target.value)}
  style={{
    padding: "8px 10px",
    border: "1px solid #ddd",
    borderRadius: 6,
  }}
>
  <option value="">All Months</option>
  <option value="1">January</option>
  <option value="2">February</option>
  <option value="3">March</option>
  <option value="4">April</option>
  <option value="5">May</option>
  <option value="6">June</option>
  <option value="7">July</option>
  <option value="8">August</option>
  <option value="9">September</option>
  <option value="10">October</option>
  <option value="11">November</option>
  <option value="12">December</option>
</select>

{/* Year */}
<select
  value={selectedYear}
  onChange={(e) => setSelectedYear(e.target.value)}
  style={{
    padding: "8px 10px",
    border: "1px solid #ddd",
    borderRadius: 6,
  }}
>
  <option value="">All Years</option>
  <option value="2024">2024</option>
  <option value="2025">2025</option>
  <option value="2026">2026</option>
</select>

{/* Clear */}
{(selectedMonth || selectedYear) && (
  <Button
    size="small"
    onClick={() => {
      setSelectedMonth("");
      setSelectedYear("");
    }}
  >
    Clear
  </Button>
)}
</Box>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Invoice</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredInvoices.map((inv) => (
              <TableRow key={inv.id}>
                <TableCell>{inv.id}</TableCell>

                <TableCell>
                  {new Date(inv.created * 1000).toLocaleDateString()}
                </TableCell>

                <TableCell>
                  <Chip
                    label={inv.status}
                    color={
                      inv.status === "paid"
                        ? "success"
                        : inv.status === "open"
                        ? "warning"
                        : "default"
                    }
                  />
                </TableCell>

                <TableCell>€{inv.amount.toFixed(2)}</TableCell>

                <TableCell>
                  <Button
                    size="small"
                    onClick={() => window.open(inv.hostedUrl)}
                  >
                    View
                  </Button>

                  <Button
                    size="small"
                    onClick={() => window.open(inv.invoicePdf)}
                  >
                    Download PDF
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </>
    )}

   {/* ---------------- CANCEL ACCOUNT TAB ---------------- */}
{selectedTab === "cancel_account" && (
  <>
    <Typography variant="h6" gutterBottom>
      Cancel Account
    </Typography>

    <Divider sx={{ my: 2 }} />

    <Alert severity="warning" sx={{ mb: 3 }}>
      <Typography variant="body2">
        <strong>Warning:</strong> This action is permanent and cannot be
        undone.
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        All data associated with this account will be permanently deleted
        within the next 2 hours.
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        Any outstanding charges will be billed to your default payment
        method. Once all outstanding amounts have been settled, your payment
        method will be removed from our records.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        You can still access your account meanwhile.
      </Typography>
    </Alert>

    <Typography variant="body2" sx={{ mb: 1 }}>
      To confirm, type{" "}
      <strong>permanently delete</strong> below.
    </Typography>

    <TextField
      fullWidth
      value={deleteConfirmation}
      onChange={(e) => setDeleteConfirmation(e.target.value)}
      placeholder="permanently delete"
      sx={{ mb: 3 }}
    />

    <Button
      variant="contained"
      color="error"
      disabled={
        deleteConfirmation.trim() !== "permanently delete" || loading
      }
      onClick={canelAccount}
    >
      {loading ? "Cancelling..." : "Cancel Account"}
    </Button>

    {cancelSuccess && (
      <Alert severity="success" sx={{ mt: 3 }}>
        Account cancellation initiated. Your account and associated data will
        be permanently deleted within the next 2 hours.
      </Alert>
    )}
  </>
)}



  </div>
</div>
 ) : (
  <div style={{ padding: 72, textAlign: "center" }}>
    <h3>You are not authorized to view this page</h3>
  </div>
)


  );

}
